<template>
  <div class="case">
    <banner title="经典案例" subtitle="SUCCESSFUL CASES" />
    <div class="case-section" v-loading="loading">
      <div class="container">
        <div class="case-grid">
          <router-link
            v-for="cas in caseList"
            :key="cas.Id"
            class="case-card"
            :to="{ name: 'casedetails', params: { id: cas.Id } }"
          >
            <div class="case-media">
              <img v-lazy="$img(cas.Img)" :alt="cas.Title" />
            </div>
            <div class="case-body">
              <h4>{{ cas.Title }}</h4>
              <p>{{ truncate(cas.Content) }}</p>
              <span class="more">查看详情 &gt;</span>
            </div>
          </router-link>
        </div>
        <div v-if="!loading && !caseList.length" class="empty-tip">暂无案例数据</div>

        <el-pagination
          v-if="caseTotal > casePageSize"
          class="case-pager"
          layout="prev, pager, next, jumper, total"
          :page-size="casePageSize"
          :current-page.sync="casePage"
          :total="caseTotal"
          background
        />
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: { Banner },
  data() {
    return {
      loading: true,
      caseList: [],
      casePage: 1,
      casePageSize: 6,
      caseTotal: 0
    };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    casePage() {
      this.loadData();
    }
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$http
        .get(`Case/Page?page=${this.casePage}&size=${this.casePageSize}`)
        .then(response => {
          const data = response.data || {};
          this.caseList = data.Items || data.items || [];
          this.caseTotal = data.Total || data.total || 0;
          this.loading = false;
        })
        .catch(() => {
          this.caseList = [];
          this.caseTotal = 0;
          this.loading = false;
        });
    },
    truncate(html) {
      if (!html) return "";
      const text = String(html).replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
      return text.length > 60 ? text.slice(0, 60) + "..." : text;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/variables.scss";

.case {
  width: 100%;
  background: $color-bg-2;
  padding-bottom: 60px;
}

.case-section {
  padding: 28px 0 0;
}

.case-grid {
  display: grid;
  // minmax(0, 1fr) 强制 3 等宽:不让内容撑大某列把别的列压扁
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px;
}

.case-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid $color-border;
  color: $color-text;
  transition: border-color 0.2s ease;
  // grid item 显式 min-width:0,避免被 .case-body h4 长标题撑大(默认 min-width:auto = min-content)
  min-width: 0;

  &:hover {
    border-color: $color-accent;
    color: $color-accent;
  }
}

.case-media {
  width: 100%;
  height: 140px;
  overflow: hidden;
  border-bottom: 1px solid $color-border;
  background: #e8e8e8;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.case-body {
  padding: 16px 24px 18px;
  flex: 1;
  display: flex;
  flex-direction: column;

  h4 {
    margin: 0 0 8px;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // h4 默认 block 元素 min-width:auto = min-content(标题不换行),加 0 让 ellipsis 真正生效
    min-width: 0;
  }

  p {
    margin: 0 0 12px;
    color: $color-text-2;
    font-size: 13px;
    line-height: 1.7;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    min-height: 44px;
  }
}

.more {
  margin-top: auto;
  color: $color-accent;
  font-size: 13px;
  letter-spacing: 1px;
}

.empty-tip {
  text-align: center;
  color: $color-text-3;
  padding: 60px 0;
  background: #fff;
  border: 1px solid $color-border;
}

.case-pager {
  padding: 24px;
  text-align: center;
}

@media (max-width: 960px) {
  .case-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 18px; }
}

@media (max-width: 640px) {
  .case-grid { grid-template-columns: 1fr; }
  .case-media { height: 140px; }
}
</style>
